import { FormEvent, useEffect, useState } from "react";
import { VideoVisibilityForm } from "./components/VideoVisibilityForm";
import { DownArrowIcon, TrashIcon } from "assets";
import { ApiError, CustomTooltip, SmallScreenModel } from "components";
import { updateVideoFeatured, updateVideoVisibility } from "../store/action";
import { UpdateSingleDataInput, VideoDetailProps } from "../store/actionType";
import { connect, useSelector } from "react-redux";
import { VideoFeaturedForm } from "./components/VideoFeaturedForm";

interface OwbProps {
  videoData: VideoDetailProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwbProps;
const UpdateVideoFeatured: React.FC<Props> = ({
  onUpdateFeatured,
  videoData,
}) => {
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );
  const [openModel, setOpenModel] = useState(false);
  const [featured, setFeatured] = useState(videoData?.featured);
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { value } = e.target;
    setFeatured(value);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    const input: UpdateSingleDataInput = {
      field: "featured",
      value: featured,
      video_id: videoData.id.toString(),
    };
    onUpdateFeatured(input);
  };
  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error); 
      } else if (videoDetailsState.status === "SUCCESS") {
        setApiError(null);
        setOpenModel(false);
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);
  return (
    <>
      <CustomTooltip title="update Video Featured" placement="right">
        <button onClick={() => setOpenModel(true)}>
          <DownArrowIcon className="size-4 mr-2 text-gray-600 hover:text-black" />
        </button>
      </CustomTooltip>
      <SmallScreenModel setShowModal={setOpenModel} showModal={openModel}>
        <VideoFeaturedForm
          loading={false}
          featured={featured}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
        {apiError && <ApiError>{apiError}</ApiError>}
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateFeatured: (input: UpdateSingleDataInput) =>
    dispatch(updateVideoFeatured(input)),
});

export default connect(null, mapDispatchToProps)(UpdateVideoFeatured);
